export default __webpack_public_path__ + "static/media/upload.2f154be9.svg";